var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerified = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#verified_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m22.343 5.515-2.222-2.222a3 3 0 0 0-4.242 0l-2.222 2.222h-3.142a3 3 0 0 0-3 3v3.142l-2.222 2.222a3 3 0 0 0 0 4.242l2.222 2.222v3.142a3 3 0 0 0 3 3h3.142l2.222 2.222a3 3 0 0 0 4.242 0l2.222-2.222h3.142a3 3 0 0 0 3-3v-3.142l2.222-2.222a3 3 0 0 0 0-4.242l-2.222-2.222V8.515a3 3 0 0 0-3-3zm-1.121 1.707a1 1 0 0 0 .707.293h3.556a1 1 0 0 1 1 1v3.556a1 1 0 0 0 .293.707l2.515 2.515a1 1 0 0 1 0 1.414l-2.515 2.515a1 1 0 0 0-.293.707v3.556a1 1 0 0 1-1 1H21.93a1 1 0 0 0-.707.293l-2.515 2.515a1 1 0 0 1-1.414 0l-2.515-2.515a1 1 0 0 0-.707-.293h-3.556a1 1 0 0 1-1-1V19.93a1 1 0 0 0-.293-.707l-2.515-2.515a1 1 0 0 1 0-1.414l2.515-2.515a1 1 0 0 0 .293-.707V8.515a1 1 0 0 1 1-1h3.556a1 1 0 0 0 .707-.293l2.515-2.515a1 1 0 0 1 1.414 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35ADE9",
  d: "M21.929 7.515a1 1 0 0 1-.707-.293l-2.515-2.515a1 1 0 0 0-1.414 0l-2.515 2.515a1 1 0 0 1-.707.293h-3.556a1 1 0 0 0-1 1v3.556a1 1 0 0 1-.293.707l-2.515 2.515a1 1 0 0 0 0 1.414l2.515 2.515a1 1 0 0 1 .293.707v3.556a1 1 0 0 0 1 1h3.556a1 1 0 0 1 .707.293l2.515 2.515a1 1 0 0 0 1.414 0l2.515-2.515a1 1 0 0 1 .707-.293h3.556a1 1 0 0 0 1-1V19.93a1 1 0 0 1 .293-.707l2.515-2.515a1 1 0 0 0 0-1.414l-2.515-2.515a1 1 0 0 1-.293-.707V8.515a1 1 0 0 0-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m23.374 13.374-6.707 6.707-3.374-3.374 1.414-1.414 1.96 1.96 5.292-5.293z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "verified_svg__a",
  width: 40,
  height: 40,
  x: -2,
  y: -2,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_245_18698"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_245_18698",
  result: "shape"
})))));
export { SvgVerified as ReactComponent };
export default __webpack_public_path__ + "d44acb00e4bdb31332011509d3f29413.svg";